/**
 * Когда в карточке цели уместен выбор Пешком/Авто/Фура (запрос владельца
 * 03.08.2026): внутри здания предлагать транспорт бессмысленно, а из дома
 * или через территорию — нужно. Критерий не «где цель», а «каков путь»:
 *  1) у площадки вообще нет транспортных дорог → выбора нет;
 *  2) человек вне площадки (гео за bbox) → выбор есть (он ещё поедет);
 *  3) пеший маршрут задевает дорожные рёбра → выбор есть;
 *  4) иначе (весь путь по помещению/двору пешком) → выбора нет.
 * Пеший маршрут как эталон намеренно: критерий не должен зависеть от уже
 * выбранного режима, иначе чипы мигали бы при переключении.
 */
import type { LonLat } from '@app/geo'
import { type BuiltGraph, routeUsesRoads, type Venue } from '@app/rvf'

export function hasVehicleNetwork(venue: Venue): boolean {
  return venue.network.edges.some((e) => e.vehicle === true || e.truck === true)
}

/** Гео-позиция за пределами площадки (bbox [w,s,e,n]) — человек ещё в пути. */
export function outsideVenue(venue: Venue, geo: LonLat | null): boolean {
  if (!geo) return false
  const [w, s, e, n] = venue.venue.bbox
  const [lon, lat] = geo
  return lon < w || lon > e || lat < s || lat > n
}

/** Показывать ли выбор транспорта; footNodeIds — узлы ПЕШЕГО маршрута. */
export function showTravelChoice(
  venue: Venue,
  graph: BuiltGraph,
  footNodeIds: readonly string[] | null,
  geo: LonLat | null,
): boolean {
  if (!hasVehicleNetwork(venue)) return false
  if (outsideVenue(venue, geo)) return true
  return footNodeIds !== null && routeUsesRoads(graph, footNodeIds)
}
